import { useState, useEffect } from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import * as contentful from 'contentful-management';

const defaultValues = {
	studiosData: {
		studios: [],
		allFilters: {},
	},
};

const client = contentful.createClient({
	accessToken: process.env.GATSBY_CONTENTFUL_MANAGEMENT_TOKEN,
});

const useStudios = () => {
	const { allContentfulStudios } = useStaticQuery(
		graphql`
			{
				allContentfulStudios {
					nodes {
					  	total
					  	studios {
							sys {
						  		id
							}
							businessName
							contactName
							email
							streetAddress1
							streetAddress2
							city
							state
							postalCode
							country
							telephoneBusiness
							websiteUrl
							publish
							approved
							location {
								lat
								lon
							}
							filters {
								equipment
							}
					  	}
					}
				}
			}
		`
	);

	const [studiosData, setStudiosData] = useState(defaultValues.studiosData);
	const [studioFinderForm, setStudioFinderForm] = useState(false);
	const [contentfulApi, setContentfulApi] = useState(null);

	//	---------------------------------------
	//	Create contetful api to manipulate data
	//	---------------------------------------
	useEffect(() => {
		if (studioFinderForm && !contentfulApi) {
			client.getSpace(process.env.GATSBY_CONTENTFUL_SPACE_ID)
				.then(space => space.getEnvironment(process.env.GATSBY_CONTENTFUL_ENV))
				.then(environment => setContentfulApi(environment))
				.catch(window.console.error);
		}
	}, [studioFinderForm]); // eslint-disable-line

	//	---------------------------------------
	//	Map Studio data fetched from contentful
	//	---------------------------------------
	useEffect(() => {
		const studiosInfo = allContentfulStudios.nodes[0].studios
			// parse data
			.map(_studio => {
				try {
					const equipment = JSON.parse(_studio.filters.equipment) || {};
					return {
						..._studio,
						equipment,
						location: {
							lat: _studio.location?.lat,
							lng: _studio.location?.lon,
						},
					};
				} catch {
					window.console.error(`couldn't parse filters data of this studio`, _studio);
					return {
						..._studio,
						equipment: {},
					};
				}
			})
			// create an object that includes all studios info and all filteration info
			.reduce((accumulated, _studio) => {
				const { equipment } = _studio;
				const { studios, allFilters } = accumulated;

				studios.push(_studio);
				Object.entries(equipment).forEach(([k, v]) => {
					if (!allFilters[k]) {
						allFilters[k] = ['All', ...v];
					}
					allFilters[k] = [...new Set([...allFilters[k], ...v])];
				});

				return accumulated;
			}, {
				studios: [],
				allFilters: {},
			});

		setStudiosData(() => studiosInfo);
	}, []); // eslint-disable-line

	return {
		studiosData,
		setStudiosData,
		studioFinderForm,
		setStudioFinderForm,
		contentfulApi,
	};
};

export default useStudios;
